import * as React from 'react';
import { Card, Button, Breadcrumb, Icon, Modal, Row, Col, Radio, Dropdown, Menu, Spin } from 'antd';
import ProfileList from './profile/ProfileList';
import ProfileAddEdit from './profile/ProfileAddEdit';
import ProfileFilter from './profile/ProfileFilter';
import { IcommonProps } from './common/props';
import service from '../service/apolloclient.service';
import '../css/Profile.scss';
import Constants from './common/constants';
import ViewProfile from './profile/ViewProfile';
import Comparator from './common/comparer';
import Util from './common/utils';
import Print from './common/print';
import Export from './common/export';
// import { historyNotifier } from './common/historyNotifier';
import { staticProperties, STATICKEYS } from './common/staticProperties';
import { Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ProfileBulkUpload from './profile/ProfileBulkUpload';
import { VIEWSTATE } from './common/constants';
import LocalStorage from '../service/localstorage';
import Auth from './common/auth';
import { Tasks } from './common/auth';
import { BASELINETYPE } from './common/constants';
import strings from '../eyeguide-localization/profile/strings.profile';
import Token from './common/token';

const RadioGroup = Radio.Group;
const storage = new LocalStorage();

const VIEWS = {
    ADDPROFILE: '/profile/add/',
    EDITPROFILE: '/profile/edit/',
    VIEWPROFILE: '/profile/view/',
    BULKUPLOAD: '/profile/upload/',
};

interface IrosterProps extends IcommonProps {
    navigateFrom: string;
    match: any;
    url: any;
    location: any;
    type: number;
}

interface IrosterState {
    origprofiles: any;
    profiles: any;
    error: boolean;
    shareprofiles: Array<string>;
    view: string;
    profileAddEditTitle: string;
    breadCrumbValue: string;
    profileToEdit: any;
    profileToView: any;
    tests: any;
    modalVisible: boolean;
    filterObj: any;
    prevFilterObj: any;
    organizations: any;
    disableAdd: boolean;
    showProfileList: any;
    printModalVisible: boolean;
    printTests: boolean;
    exportModalVisisble: boolean;
    printTestOpt: number;
    navigationFrom: number;
    rosterName: string;
    emptyText: string;
    loading: boolean;
    testListLoading: boolean;
    testListText: string;
    canAddProfile: boolean;
    canUploadProfile: boolean;
    showHealthData: boolean;
    orgNames: string;
    isFocusUser: boolean;
    isDownloading: boolean;
    exportWithTests: boolean;
}

export default class Profiles extends React.Component<IrosterProps, IrosterState> {
    iframe: HTMLIFrameElement | null;
    menu = (
        <Menu onClick={(obj) => this.exportFile(obj.key)}>
            <Menu.Item key="1">{strings.lsCSVTxt}</Menu.Item>
            <Menu.Item key="2">{strings.lsCSVTxt + ' with Tests'}</Menu.Item>
        </Menu>
    );
    constructor(props: IrosterProps) {
        super(props);
        let roleid: number = parseInt(Token.decodeToken().roleid, 10);
        this.state = {
            origprofiles: [],
            error: false,
            profiles: [],
            shareprofiles: [],
            view: '',
            profileAddEditTitle: strings.lsViewProfilesTxt,
            breadCrumbValue: strings.lsProfilesTxt,
            profileToEdit: '',
            tests: new Map(),
            modalVisible: false,
            filterObj: JSON.parse(storage.getFilterObj()),
            prevFilterObj: {},
            profileToView: '',
            organizations: [],
            disableAdd: true,
            showProfileList: true,
            printModalVisible: false,
            printTests: true,
            exportModalVisisble: false,
            printTestOpt: 0,
            navigationFrom: 0,
            rosterName: '',
            emptyText: '',
            loading: true,
            testListLoading: true,
            testListText: '',
            canAddProfile: Auth.canPerformTask(roleid, Tasks.canAddProfile),
            canUploadProfile: Auth.canPerformTask(roleid, Tasks.canUploadProfiles),
            showHealthData: Auth.canPerformTask(roleid, Tasks.canViewHealthData),
            isFocusUser: Auth.canPerformTask(roleid, Tasks.isFocusUser),
            orgNames: '',
            isDownloading: false,
            exportWithTests: false,
        };
        this.getTestsForLastBaseline = this.getTestsForLastBaseline.bind(this);
        this.changeFilter = this.changeFilter.bind(this);
        // historyNotifier.addEventListener('Profile', this.getCompState, this.setCompState);
    }

    async componentDidMount() {
        console.log('props', this.props.match.params.rosterid);
        Util.resetScroll();

        if (!this.ifRouteExists(this.props)) {
            staticProperties.set(STATICKEYS.selectedRoster, this.props.match.params.rosterid);
            staticProperties.set(
                STATICKEYS.selectedKey,
                this.props.match.params.rosterid + VIEWSTATE.ROSTER
            );

            this.intializeProfileList(
                this.props.match.params.rosterid,
                this.props.type,
                this.props.match.params.orgid
            );
            this.getOrganizations();
            this.getRoster(this.props.match.params.rosterid);
            this.props.enableTitleSpace(true);
            let user = Token.decodeToken();
            this.setState({
                canAddProfile: user.canaddprofile === 1,
            });
        }
    }

    async componentWillReceiveProps(nextProps: any) {
        Util.resetScroll();
        console.log('nextProps.orgId', nextProps);
        console.log('in props');
        if (!this.ifRouteExists(nextProps)) {
            staticProperties.set(STATICKEYS.selectedRoster, nextProps.match.params.rosterid);
            staticProperties.set(
                STATICKEYS.selectedKey,
                nextProps.match.params.rosterid + VIEWSTATE.ROSTER
            );

            if (staticProperties.get(STATICKEYS.rerender) === true) {
                this.clearFilters(nextProps, false);
                staticProperties.set(STATICKEYS.rerender, false);
            }

            if (this.props.match.params.rosterid !== nextProps.match.params.rosterid) {
                console.log('inside recieve for innitializing');
                this.getRoster(nextProps.match.params.rosterid);
                this.intializeProfileList(
                    nextProps.match.params.rosterid,
                    nextProps.type,
                    nextProps.match.params.orgid
                );

                this.setState({
                    view: VIEWS.ADDPROFILE,
                    breadCrumbValue: 'Profiles',
                    profileAddEditTitle: 'View Profiles',
                    profileToEdit: '',
                });
            }
        }
    }

    render() {
        if (this.state.isFocusUser && storage.getSelectedOrg() === '') {
            history.forward();
            return <div />;
        } else {
            let dateRange = this.state.prevFilterObj.hasOwnProperty('dateRange')
                ? this.state.prevFilterObj.dateRange
                : ['', ''];
            return (
                <div>
                    <Spin
                        spinning={this.state.isDownloading}
                        size="large"
                        style={{ position: 'absolute', zIndex: 100, left: '50%', top: '50%' }}
                    />
                    <Route
                        path={VIEWS.EDITPROFILE + ':playerid'}
                        render={(props: any) => (
                            <ProfileAddEdit
                                save=""
                                cancel=""
                                organizationName={this.props.organizationName}
                                enableTitleSpace={this.props.enableTitleSpace}
                                organizationID={this.props.organizationID}
                                navigationFrom={this.state.navigationFrom}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path={VIEWS.ADDPROFILE + ':rosterid'}
                        render={(props: any) => (
                            <ProfileAddEdit
                                save=""
                                cancel=""
                                organizationName={this.props.organizationName}
                                enableTitleSpace={this.props.enableTitleSpace}
                                organizationID={this.props.organizationID}
                                navigationFrom={this.state.navigationFrom}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path={VIEWS.VIEWPROFILE + ':playerid'}
                        render={(props: any) => (
                            <ViewProfile
                                profile={this.state.profileToView}
                                cancel=""
                                organizationName={this.props.organizationName}
                                enableTitleSpace={this.props.enableTitleSpace}
                                organizationID={this.props.organizationID}
                                rosterID={this.props.rosterID}
                                navigateFrom={this.props.navigateFrom}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path={VIEWS.BULKUPLOAD + ':rosterid'}
                        render={(props: any) => (
                            <ProfileBulkUpload
                                profiles={this.state.profiles}
                                filterObj={this.state.filterObj}
                                {...props}
                            />
                        )}
                    />
                    {this.ifRouteExists(this.props) ? (
                        ''
                    ) : (
                        <div
                            className="Profile"
                            style={{ pointerEvents: this.state.isDownloading ? 'none' : 'auto' }}
                        >
                            <Card>
                                <Breadcrumb>
                                    <Breadcrumb.Item>
                                        <a href="/dashboard">{strings.lsHomeTxt}</a>
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item>
                                        {this.state.rosterName + ' ' + strings.lsProfilesTxt}
                                    </Breadcrumb.Item>
                                </Breadcrumb>
                                <br />
                                <h3>{this.state.profileAddEditTitle} </h3>
                            </Card>
                            <div className="contentWithoutTitle">
                                <Card className="filterCard">
                                    <span
                                        className="filterIcon"
                                        onClick={(e) => {
                                            console.log('clicked');
                                            this.getDistinctOrganizations();
                                            this.setState({
                                                modalVisible: true,
                                            });
                                        }}
                                    >
                                        <Icon
                                            type="filter"
                                            style={{ fontSize: 19, float: 'right' }}
                                        />
                                    </span>
                                    <span style={{ fontSize: '14px', fontWeight: 'normal' }}>
                                        <span hidden={this.checkIfFilterExists('', true)}>
                                            {strings.lsNoFilterTxt}
                                        </span>
                                        <div
                                            className="filterContent"
                                            hidden={!this.checkIfFilterExists('', true)}
                                        >
                                            <Button
                                                className="clearFilter"
                                                onClick={(e) => {
                                                    this.clearFilters(this.props);
                                                }}
                                            >
                                                {strings.lsClearFilterTxt}
                                            </Button>
                                            <Row
                                                className="filterRow"
                                                hidden={this.checkIfFilterExists('firstname')}
                                            >
                                                <Col span={5}>{strings.lsProfileFNameTxt}:</Col>
                                                <Col span={15}>
                                                    {' '}
                                                    {this.getFilterValues('firstname')}{' '}
                                                </Col>
                                            </Row>
                                            <Row
                                                className="filterRow"
                                                hidden={this.checkIfFilterExists('middlename')}
                                            >
                                                <Col span={5}>{strings.lsProfileMNameTxt}:</Col>
                                                <Col span={15}>
                                                    {' '}
                                                    {this.getFilterValues('middlename')}{' '}
                                                </Col>
                                            </Row>
                                            <Row
                                                className="filterRow"
                                                hidden={this.checkIfFilterExists('lastname')}
                                            >
                                                <Col span={5}>{strings.lsProfileLNameTxt}:</Col>
                                                <Col span={15}>
                                                    {this.getFilterValues('lastname')}
                                                </Col>
                                            </Row>
                                            <Row
                                                className="filterRow"
                                                hidden={this.checkIfFilterExists('profileID')}
                                            >
                                                <Col span={5}>{strings.lsProfileIDTxt}:</Col>
                                                <Col span={15}>
                                                    {this.getFilterValues('profileID')}{' '}
                                                </Col>
                                            </Row>
                                            <Row
                                                className="filterRow"
                                                hidden={this.checkIfFilterExists('gender')}
                                            >
                                                <Col span={5}>{strings.lsProfileGenderTxt}:</Col>
                                                <Col span={15}>
                                                    {this.getFilterValues('gender')}
                                                </Col>
                                            </Row>
                                            <Row
                                                className="filterRow"
                                                hidden={this.checkIfFilterExists('dateRange')}
                                            >
                                                <Col span={5}>
                                                    {dateRange[0] !== dateRange[1]
                                                        ? strings.lsDateRangeTxt
                                                        : strings.lsTestDateTxt}
                                                    :
                                                </Col>
                                                <Col span={15}>
                                                    {dateRange[0] !== dateRange[1]
                                                        ? dateRange[0] + ' ... ' + dateRange[1]
                                                        : dateRange[0]}
                                                </Col>
                                            </Row>
                                            <Row
                                                className="filterRow"
                                                hidden={this.checkIfFilterExists('level')}
                                            >
                                                <Col span={5}>{strings.lsProfileLevelTxt}:</Col>
                                                <Col span={15}>{this.getFilterValues('level')}</Col>
                                            </Row>
                                            <Row
                                                className="filterRow"
                                                hidden={this.checkIfFilterExists(
                                                    'organizationname'
                                                )}
                                            >
                                                <Col span={5}>{strings.lsOrgTxt}:</Col>
                                                <Col span={15}>
                                                    {this.getFilterValues('organizationname')}
                                                </Col>
                                            </Row>
                                            <Row
                                                className="filterRow"
                                                hidden={this.checkIfFilterExists('notifyEmail')}
                                            >
                                                <Col span={5}>
                                                    {' '}
                                                    {strings.lsProfileNotifyEmailsTxt}:
                                                </Col>
                                                <Col span={15}>
                                                    {this.getFilterValues('notifyEmail')}
                                                </Col>
                                            </Row>
                                            <Row
                                                className="filterRow"
                                                hidden={this.checkIfFilterExists('notifyPhone')}
                                            >
                                                <Col span={5}>
                                                    {strings.lsProfileNotifyPhonesTxt}:
                                                </Col>
                                                <Col span={15}>
                                                    {this.getFilterValues('notifyPhone')}
                                                </Col>
                                            </Row>
                                        </div>
                                    </span>
                                </Card>
                                <Card
                                    title={strings.lsViewProfilesTxt}
                                    bordered={false}
                                    className="card"
                                >
                                    <Link
                                        style={{ color: 'white', paddingLeft: '5px' }}
                                        to={'/profile/add/' + this.props.match.params.rosterid}
                                    >
                                        <Button
                                            type="primary"
                                            icon="plus-circle-o"
                                            disabled={
                                                this.state.disableAdd || !this.state.canAddProfile
                                            }
                                            // onClick={() => <Redirect to={VIEWS.ADDPROFILE}/>}
                                        >
                                            {strings.lsAddProfileTxt}
                                        </Button>
                                    </Link>
                                    <Link
                                        style={{ color: 'white', paddingLeft: '5px' }}
                                        to={'/profile/upload/' + this.props.match.params.rosterid}
                                    >
                                        <Button
                                            type="primary"
                                            icon="upload"
                                            disabled={
                                                this.state.disableAdd || !this.state.canAddProfile
                                            }
                                        >
                                            {strings.lsUpldProfileTxt}
                                        </Button>
                                    </Link>
                                    <Dropdown
                                        trigger={['click']}
                                        overlay={this.menu}
                                        getPopupContainer={this.getContainer}
                                    >
                                        <Button className="downloadBtn">
                                            {strings.lsDnwldProfileTxt}{' '}
                                            <Icon type="down" style={{ fontSize: 10 }} />{' '}
                                        </Button>
                                    </Dropdown>
                                    <Modal
                                        title={strings.lsViewProfileExportTxt}
                                        visible={this.state.exportModalVisisble}
                                        onOk={() => this.setState({ exportModalVisisble: false })}
                                        okText={strings.lsOkTxt}
                                        width={450}
                                        bodyStyle={{ padding: 0 }}
                                        maskClosable={false}
                                        closable={false}
                                        footer={[
                                            <Button
                                                key="Ok"
                                                type="primary"
                                                onClick={() =>
                                                    this.setState({ exportModalVisisble: false })
                                                }
                                            >
                                                {strings.lsOkTxt}
                                            </Button>,
                                        ]}
                                    >
                                        <Row style={{ padding: '19px' }}>
                                            {this.state.exportWithTests
                                                ? strings.lsExportProfileSuccessTxt.replace(
                                                      'without',
                                                      'with'
                                                  )
                                                : strings.lsExportProfileSuccessTxt}
                                        </Row>
                                    </Modal>
                                    <Button
                                        style={{ marginLeft: 10, marginBottom: 20, float: 'right' }}
                                        onClick={() => this.printListConfirm()}
                                    >
                                        {strings.lsProfilePrintTxt}
                                    </Button>
                                    <Modal
                                        title={strings.lsProfileListPrintTxt}
                                        visible={this.state.printModalVisible}
                                        okText={strings.lsProfilePrintTxt}
                                        onOk={() => this.setPrintModalVisible(1)}
                                        onCancel={() => this.setPrintModalVisible(0)}
                                        width={700}
                                        bodyStyle={{ padding: 0 }}
                                        maskClosable={false}
                                        closable={false}
                                    >
                                        <Card
                                            className="filterCard"
                                            bordered={false}
                                            style={{ margin: '24px 16px' }}
                                        >
                                            <Row className="row">
                                                <Col xs={1} sm={1} md={1} lg={5} xl={4} />
                                                <Col xs={14} sm={14} md={16} lg={10} xl={16}>
                                                    <span>{strings.lsProfilePrintSelectTxt}</span>
                                                </Col>
                                                <Col xs={1} sm={1} md={2} lg={6} xl={4} />
                                            </Row>

                                            <Row className="row">
                                                <Col xs={1} sm={1} md={1} lg={5} xl={4} />
                                                <Col xs={14} sm={14} md={16} lg={10} xl={16}>
                                                    <div className="printOptions">
                                                        <RadioGroup
                                                            className="labelFrame"
                                                            value={this.state.printTestOpt}
                                                            onChange={(val) => {
                                                                this.handleChange(val.target.value);
                                                                this.setState({
                                                                    printTestOpt: val.target.value,
                                                                });
                                                            }}
                                                        >
                                                            <Radio defaultChecked={true} value={0}>
                                                                {strings.lsProfilePrintWithTestTxt}
                                                            </Radio>
                                                            <Radio defaultChecked={false} value={1}>
                                                                {
                                                                    strings.lsProfilePrintWithoutTestTxt
                                                                }
                                                            </Radio>
                                                        </RadioGroup>
                                                    </div>
                                                </Col>
                                                <Col xs={1} sm={1} md={2} lg={6} xl={4} />
                                            </Row>
                                        </Card>
                                    </Modal>
                                    <iframe
                                        style={{ height: 0, width: 0, border: 'none' }}
                                        ref={(el) => (this.iframe = el)}
                                    />
                                    <ProfileList
                                        organizationID={this.props.organizationID}
                                        rosterID={this.props.rosterID}
                                        profiles={this.state.profiles}
                                        organizationName={this.props.organizationName}
                                        enableTitleSpace={this.props.enableTitleSpace}
                                        notifyShowTestsClick={this.getTestsForLastBaseline}
                                        tests={this.state.tests}
                                        showOrg={
                                            this.props.type ===
                                            Constants.getProfileListTypes().DEFAULT
                                                ? false
                                                : true
                                        }
                                        showNotifs={
                                            this.props.type ===
                                            Constants.getProfileListTypes().BASELINES_PENDING
                                                ? true
                                                : false
                                        }
                                        emptyText={this.state.emptyText}
                                        loading={this.state.loading}
                                        testListLoading={this.state.testListLoading}
                                        testListText={this.state.testListText}
                                    />
                                </Card>
                            </div>
                            <Modal
                                className="modal"
                                title={strings.lsProfileListFilterTxt}
                                visible={this.state.modalVisible}
                                okText={strings.lsFilterTxt}
                                onOk={() => this.setModalVisible(1)}
                                onCancel={() => this.setModalVisible(0)}
                                width={1000}
                                bodyStyle={{ padding: 0 }}
                                maskClosable={false}
                                closable={false}
                                destroyOnClose={true}
                            >
                                <ProfileFilter
                                    notifyChangeFilter={this.changeFilter}
                                    form={''}
                                    showOrg={
                                        this.props.type === Constants.getProfileListTypes().DEFAULT
                                            ? false
                                            : true
                                    }
                                    showNotifs={
                                        this.props.type ===
                                        Constants.getProfileListTypes().BASELINES_PENDING
                                            ? true
                                            : false
                                    }
                                    isOpen={this.state.modalVisible}
                                    organization={this.state.organizations}
                                    filterObj={this.state.filterObj}
                                    orgs={this.state.orgNames}
                                />
                            </Modal>
                        </div>
                    )}
                </div>
            );
        }
    }

    private async getTestsForLastBaseline(playerid: string) {
        let ser = new service();
        let d = new Date().toISOString();
        let dateRange = [];
        if (this.state.filterObj.hasOwnProperty('dateRange')) {
            dateRange = this.state.filterObj.dateRange;
        }
        console.log('TestsAfterLastBaseline');
        let tests: any = await ser.getTestsAfterLastBaseline(playerid, d, dateRange);
        console.log('TestsAfterLastBaseline', tests);
        let testMap = this.state.tests;
        testMap.set(playerid, tests);
        this.setState({
            tests: testMap,
            testListLoading: false,
            testListText: tests.length === 0 ? 'No Data' : '',
        });
        // return tests;
    }

    /**
     * Fetches the list of profiles from server
     * @param rosterID RosterId of Sub Org selected from side menu
     */
    private async intializeProfileList(
        rosterID: string,
        profileListFor: any,
        orgId: any,
        filterCleared: boolean = false
    ) {
        let profiles: any;
        let ser = new service();
        console.log('intializeProfileList', rosterID, orgId);
        if (profileListFor === Constants.getProfileListTypes().DEFAULT) {
            profiles = await ser.getProfiles(rosterID);
        } else {
            profiles = await ser.getProfilesForDashboard(profileListFor, orgId);
        }
        console.log('profiles', profiles);
        this.setState({
            origprofiles: profiles,
            profiles: profiles,
            disableAdd: profileListFor === Constants.getProfileListTypes().DEFAULT ? false : true,
            emptyText: profiles.length === 0 ? 'No data' : '',
            loading: false,
        });
        this.filterList();
    }

    private async getOrganizations() {
        console.log('profiles getOrganizations');
        let ser = new service();
        let orgs = await ser.getOrganizations();
        this.setState({ organizations: orgs });
        console.log('profiles getOrganizations', orgs);
    }

    /**
     * Fetches the roster name from API to display in BreadCrumb
     * @param rosterid
     */
    private async getRoster(rosterid: string) {
        if (rosterid !== '' && rosterid !== null && rosterid !== undefined) {
            let ser = new service();
            console.log('rosterid', rosterid);
            let roster = await ser.getOrganizationByRoster(rosterid);
            this.setState({ rosterName: roster.name });
        }
    }

    /**
     * This function is called when filter changes in ProfileFilter component
     * @param filterObj Changes filter object
     */
    private async changeFilter(filterObj: any) {
        console.log('changeFilter', filterObj);
        this.setState({ filterObj: filterObj });
    }

    /**
     * Closes the filter modal and performs tasks as per the event
     * @param event Cancel/ Filter click
     */
    private setModalVisible(event: number) {
        if (event === 1) {
            // filter click
            this.filterList();
        } else {
            // cancel click
            this.setState({ filterObj: { ...this.state.prevFilterObj } });
        }
        this.setState({
            modalVisible: false,
        });
    }

    /**
     * Closes the print confirmation modal and performs tasks as per the event
     * @param event Cancel/ Print click
     */
    private setPrintModalVisible(event: number) {
        if (event === 1) {
            // print click
            this.printList();
        }
        this.setState({ printModalVisible: false, printTestOpt: 0 }, () => {
            console.log(this.state.printModalVisible);
        });
    }

    /**
     * Filters the list using the filter object created
     */
    private async filterList() {
        console.log('profilelist', this.state.filterObj);
        let filterObj = this.state.filterObj;
        let filterData: any = this.state.origprofiles;
        // let promises: any = [];
        let ser = new service();
        // let d = new Date().toISOString();
        let filteredProfiles = filterData.filter((obj: any) => {
            let matched = false;
            let comp = new Comparator();
            matched = comp.compare(filterObj, obj);
            // promises.push(ser.getTestsAfterLastBaseline(obj.playerid, d));
            console.log('comparator', matched);
            if (matched) {
                return true;
            } else {
                return false;
            }
        });
        if (filterObj.hasOwnProperty('dateRange') && filterObj.dateRange[0].length) {
            let results: any = [];
            console.log('rosterid', this.state.organizations);
            let utc1 = new Date(filterObj.dateRange[0] + ' 00:00:00').toUTCString();
            let utc2 = new Date(filterObj.dateRange[1] + ' 23:59:59').toUTCString();
            if (this.props.match.url.indexOf('dashboard') > -1) {
                let orgs = this.state.organizations;
                if (orgs[0].rosterid !== null) {
                    let promises = this.state.organizations.map((org) => {
                        return ser.getProfilesByTestDateRange(org.rosterid, [utc1, utc2], '');
                    });
                    let res: any = await Promise.all(promises);
                    results = [].concat(...res);
                } else {
                    let primarayorgid = storage.getSelectedOrgPrimary();

                    results = await ser.getProfilesByTestDateRange('', [utc1, utc2], primarayorgid);
                }
            } else {
                results = await ser.getProfilesByTestDateRange(
                    this.props.match.params.rosterid,
                    [utc1, utc2],
                    ''
                );
            }
            console.log('results', results);
            filteredProfiles = filteredProfiles.filter((fp) => {
                let temp = results.filter((p) => {
                    return p.playerid === fp.playerid;
                });
                return temp.length;
            });
            console.log('profiles', filteredProfiles);
        }
        console.log('filterObj in filterList', this.state.filterObj);
        console.log('filterObjstringfy', JSON.stringify(this.state.filterObj));
        if (this.props.type !== Constants.getProfileListTypes().DEFAULT) {
            storage.setFilterObj(JSON.stringify(this.state.filterObj));
        }
        console.log('filteredProfiles', filteredProfiles);
        this.setState({
            profiles: filteredProfiles,
            prevFilterObj: { ...this.state.filterObj },
            emptyText: filteredProfiles.length === 0 ? 'No data' : '',
            tests: new Map(),
        });
    }

    /**
     * Gets the value of property for which filter is applied
     * @param key Property for which filter is to be applied
     */
    private getFilterValues(key: string): string {
        if (this.state.prevFilterObj[key] instanceof Array) {
            console.log('gender', this.state.prevFilterObj[key]);
            let values = this.state.prevFilterObj[key];
            if (key === 'gender') {
                console.log('gennderCons', Constants.getGender());
                let valString: any = '';
                let valCons = Constants.getGender();
                for (let j = 0; j < values.length; j++) {
                    j === values.length - 1
                        ? (valString += valCons[values[j]])
                        : (valString += valCons[values[j]] + ', ');
                }
                return valString;
            } else if (key === 'dateRange') {
                return this.state.prevFilterObj[key][0];
            } else {
                let valString: any = '';
                for (let j = 0; j < values.length; j++) {
                    j === values.length - 1
                        ? (valString += values[j])
                        : (valString += values[j] + ', ');
                }
                return valString;
            }
        } else if (this.isEmpty(this.state.prevFilterObj[key])) {
            return '';
        } else {
            if (key === 'concussed') {
                console.log(
                    'consussed value',
                    Constants.getConcussionFilterValue[this.state.prevFilterObj[key]]
                );
                return Constants.getConcussionFilterValue()[this.state.prevFilterObj[key]];
            } else if (key === 'notifyEmail' || key === 'notifyPhone') {
                return Constants.getNotifyFilterType()[this.state.prevFilterObj[key]];
            }
            return this.state.prevFilterObj[key];
        }
    }

    /**
     * Checks if an object is empty
     * @param obj Object to check if empty
     */
    private isEmpty(obj: any): boolean {
        if (obj instanceof Object) {
            return Object.keys(obj).length === 0 && obj.constructor === Object;
        } else {
            return false;
        }
    }

    /**
     * Checks if any filter exists or for a particular property
     * @param property Filter property
     * @param chkIfFiltered If true, checks if any filter exists at all.
     * If false, property is checked for existence
     */
    private checkIfFilterExists(property: string, chkIfFiltered: boolean = false): boolean {
        if (chkIfFiltered) {
            console.log('isObjectEmpty', Util.isObjectEmpty(this.state.filterObj));
            return Util.isObjectEmpty(this.state.filterObj) === true ? false : true;
        } else if (Util.isObjectEmpty(this.state.filterObj) === false) {
            console.log('isObjectEmptyElse', Util.isObjectEmpty(this.state.filterObj));
            let value = this.getFilterValues(property);
            if (value === '' || value === undefined) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }

    /**
     * Shows modal for confirmation on how to print list
     */
    private printListConfirm() {
        this.setState({
            printModalVisible: true,
        });
    }

    /**
     * This is called when onChange is hit for any input control of filter
     * @param e changed value
     */
    private handleChange(e: any) {
        console.log(e);
        this.setState({
            printTests: e === 0 ? true : false,
        });
    }

    /**
     * Returns a single string containing array elements, comma seperated
     * @param arrayToConv Array to convert into singe string seperated by commas
     */
    private getCommaSepValue(arrayToConv: any) {
        let commaString: string = '';
        if (arrayToConv.length > 0) {
            arrayToConv.map((x) => {
                commaString += x + ',';
            });
        } else {
            return commaString;
        }
        console.log('commaString', commaString);
        return commaString.slice(0, -1);
    }

    /**
     * Builds print data and calls export util
     */
    private async printList() {
        console.log('profilesFromPrint', this.state.profiles);
        let playerIdArray = this.state.profiles.map((x: any) => x.playerid);
        let playerids = this.getCommaSepValue(playerIdArray);
        let buildData: any;
        if (this.state.printTests) {
            let ser: service = new service();
            let dataFromAPI = await ser.getProfile(playerids);
            if (dataFromAPI instanceof Array) {
                buildData = await this.buildAtheleteData(dataFromAPI, true);
            }
        } else {
            buildData = await this.buildAtheleteData(this.state.profiles, false);
        }
        console.log('build data', buildData);
        if (buildData.length > 0) {
            Print.printContents(buildData, strings.lsProfilesTxt, this.iframe);
            this.setState({ printTests: true });
        }
    }

    /**
     * Clears filter array which is used fo displaying and filtering data
     */
    private clearFilters(nextProps: any, reinitialize: boolean = true) {
        if (!this.ifRouteExists(nextProps)) {
            if (reinitialize) {
                this.intializeProfileList(
                    this.props.match.params.rosterid,
                    this.props.type,
                    this.props.match.params.orgid,
                    true
                );
            }
            storage.setFilterObj('{}');
            this.setState({
                filterObj: {},
                prevFilterObj: {},
            });
        }
    }

    /**
     * This function builds the data required by the Table component to display the profiles
     * @param profiles Profile array containing the profiles to be dispalyed
     */
    private async buildAtheleteData(
        profiles: Array<any>,
        showTests: boolean,
        withTestsShare: any = null
    ) {
        let columnData: Array<any> = [];
        let tests: any = [];
        let ser = new service();
        if (withTestsShare) {
            if (this.props.match.url.indexOf('dashboard') > -1) {
                let orgs = this.state.organizations;
                if (orgs[0].rosterid !== null) {
                    let promises = this.state.organizations.map((org) => {
                        return ser.getTests(org.rosterid);
                    });
                    let results: any = await Promise.all(promises);
                    tests = [].concat(...results);
                } else {
                    let primarayorgid = storage.getSelectedOrgPrimary();
                    tests = await ser.getTestsByPrimaryOrgId(primarayorgid);
                }
            } else {
                tests = await ser.getTests(this.props.match.params.rosterid);
            }
        }
        console.log('tests', tests);
        // let promises: any = [];
        let inputs: any = [];
        profiles.forEach((element: any) => {
            let data: any = {};
            if (this.state.disableAdd) {
                data.organization = element.organizationname;
            }
            data.firstname = element.firstname;
            data.lastname = element.lastname;
            // let birthdate: any;
            if (this.props.type !== Constants.getProfileListTypes().BASELINES_PENDING) {
                data.level =
                    Util.getProfileValue(element.playerinfo, 'level') !== null
                        ? Util.getProfileValue(element.playerinfo, 'level')
                        : '';
                data.gender = this.getName(
                    Util.getProfileValue(element.playerinfo, 'gender'),
                    Constants.getGender()
                );
                // if (this.state.showHealthData) {
                //     data.concussed = Util.getConcussed(element.concussed);
                // }
                data.id = Util.getProfileValue(element.playerinfo, 'profileID');
                data.middlename = Util.getProfileValue(element.playerinfo, 'middlename');
            }
            if (this.props.type === Constants.getProfileListTypes().BASELINES_PENDING) {
                data.notify_phone = Util.getProfileValue(element.playerinfo, 'notifyPhone');
                data.notify_email = Util.getProfileValue(element.playerinfo, 'notifyEmail');
            }
            if (showTests) {
                data.tests = this.buildTestData(element.tests);
            }
            let email, phone;
            if (withTestsShare !== null) {
                console.log('withTestsShare', withTestsShare);
                data.sport = Util.getProfileValue(element.playerinfo, 'sport');
                data.sport = data.sport ? data.sport : '';
                let birthdate = Util.getProfileValue(element.playerinfo, 'birthdate');
                data.birthdate = birthdate ? Util.getDateFromTimestamp(birthdate) : '';

                email =
                    Util.getProfileValue(element.playerinfo, 'email') !== null
                        ? Util.getProfileValue(element.playerinfo, 'email')
                        : '';
                phone =
                    Util.getProfileValue(element.playerinfo, 'phone') !== null
                        ? Util.getProfileValue(element.playerinfo, 'phone')
                        : '';
                data.email = email;
                data.phone = phone;
            }
            if (withTestsShare) {
                let testids = tests
                    .filter((t) => t.playerid === element.playerid)
                    .map((t) => t.testid);
                if (testids.length) {
                    console.log('testids', testids);
                }
                inputs.push({
                    organization: data.organization ? data.organization : '',
                    firstname: element.firstname,
                    lastname: element.lastname,
                    level: data.level ? data.level : '',
                    gender: data.gender ? data.gender : '',
                    sport: data.sport ? data.sport : '',
                    birthdate: data.birthdate,
                    id: data.id ? data.id : '',
                    middlename: data.middlename ? data.middlename : '',
                    email,
                    phone,
                    testids,
                });
            } else {
                columnData.push(data);
            }
        });
        console.log('column data', columnData);
        if (withTestsShare) {
            let results = await ser.createShareTestForExport(inputs);
            columnData = inputs.map((p, i) => {
                delete p.testids;
                if (p.organization.length === 0) {
                    delete p.organization;
                }
                return {
                    ...p,
                    shareLink: results[i].shareLink,
                };
            });
            return columnData;
        }
        return columnData;
    }

    private getContainer = (triggernode) => triggernode.parentNode;

    // /**
    //  * This function builds the data required by the Table component to display the profiles
    //  * @param profiles Profile array containing the profiles to be dispalyed
    //  */
    // private buildFAtheleteDataForFilter(profiles: Array<any>) {
    //     let columnData: Array<any> = [];
    //     profiles.forEach( (element: any) => {
    //         let data: any = {};
    //         data.organizationname = element.organizationname;
    //         data.firstname = element.firstname;
    //         data.lastname = element.lastname;
    //         data.level = Util.getProfileValue(element.playerinfo, 'level');
    //         data.gender = Util.getGender( Util.getProfileValue(element.playerinfo, 'gender') );
    //         data.concussed = Util.getConcussed(element.concussed);
    //         data.profileID = Util.getProfileValue(element.playerinfo, 'profileID');
    //         data.notify_phone = Util.getProfileValue(element.playerinfo, 'notifyPhone');
    //         data.notify_email = Util.getProfileValue(element.playerinfo, 'notifyEmail');
    //         columnData.push(data);
    //     });
    //     return columnData;
    // }

    /**
     * Builds export data and calls export util
     */
    private async exportFile(key: any) {
        console.log('profilesFromPrint', this.state.profiles);
        console.log('key', key);
        let buildData: any;
        let exportWithTests = key === '1' ? false : true;
        this.setState({ isDownloading: true }, async () => {
            buildData = await this.buildAtheleteData(this.state.profiles, false, exportWithTests);
            console.log('build data', buildData);
            if (buildData.length > 0) {
                Export.exportCSVFile(buildData, 'profiles');
                this.setState({
                    exportModalVisisble: true,
                    isDownloading: false,
                    exportWithTests,
                });
            } else {
                this.setState({
                    isDownloading: false,
                });
            }
        });
    }

    /**
     * Builds test data
     * @param tests Test list to be used for building data
     */
    private buildTestData(tests: Array<any>) {
        let columnData: Array<any> = [];
        tests.forEach((element: any) => {
            let data: any = {};
            if (this.state.showHealthData) {
                data = {
                    date: Util.getDate(element.testtimestamp),
                    time: Util.getTime(element.testtimestamp),
                    test_type: element.testtag,
                    score_type:
                        element.baseline === 1
                            ? BASELINETYPE.BASELINE
                            : Util.getLocalizedTestType(element.range),
                    // dr_dx_concussion: Util.getConcussed(element.concussed),
                    score: Util.formatNumber(element.score, 2),
                };
            } else {
                data = {
                    date: Util.getDate(element.testtimestamp),
                    time: Util.getTime(element.testtimestamp),
                    test_type: element.testtag,
                    score_type: element.baseline === 1 ? BASELINETYPE.BASELINE : BASELINETYPE.TEST,
                };
            }
            columnData.push(data);
        });
        return columnData;
    }

    /**
     * Returns the name from the list using the value index
     * @param value Index
     * @param list List to get from
     */
    private getName(value: any, list: any) {
        if (value !== null && value !== undefined && value.trim() !== '') {
            return list[value];
        } else {
            return '';
        }
    }

    /**
     * Checks the URL hit for other internal URL s
     * @param props Component Props
     */
    private ifRouteExists(props: any) {
        let exists = false;
        [VIEWS.ADDPROFILE, VIEWS.EDITPROFILE, VIEWS.VIEWPROFILE, VIEWS.BULKUPLOAD].forEach(
            (e: string) => {
                exists = props.location.pathname.startsWith(e) || exists;
            }
        );
        return exists;
    }

    /**
     * Sets all unique organizations from the Profile list
     */
    private getDistinctOrganizations() {
        console.log('distinct', this.state.profiles);
        let orgNames: any = [];
        // let distinctOrgs: any = [];
        this.state.origprofiles.forEach((e: any) => {
            orgNames.push(e.organizationname);
        });
        let unique = function (elems: any) {
            var seen = {};
            return elems.filter(function (e: any) {
                if (seen[e]) {
                    return;
                }
                seen[e] = true;
                return e;
            });
        };
        console.log('orgNames', unique(orgNames));
        this.setState({
            orgNames: unique(orgNames),
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/Profiles.tsx